<template>
  <header class="site-header" :class="{ 'is-en': lang === 'en' }">
    <div class="header-inner">
      <router-link class="brand" :to="homePath">
        <img class="logo" :src="fileUrl('shared/logo.png')" alt="环海运通">
        <span class="brand-text">
          <span class="brand-cn">广东环海运通国际物流有限公司</span>
          <span class="brand-en">GUANGDONG HUAN SHIPPING INTERNATIONAL LOGISTICS CO.,LTD</span>
        </span>
      </router-link>
      <nav class="nav">
        <div v-for="item in menus" :key="item.key" class="nav-item" :class="{ 'lang-item': item.isLang }">
          <router-link
            v-if="item.path"
            class="nav-link"
            :class="{ active: isActive(item.path) }"
            :to="item.path"
          >
            {{ item.name }}
            <i v-if="item.children" class="caret"></i>
          </router-link>
          <a v-else class="nav-link" href="javascript:void(0)">
            {{ item.name }}
            <i v-if="item.children" class="caret"></i>
          </a>
          <div v-if="item.children" class="dropdown" :class="{ 'lang-dropdown': item.isLang }">
            <template v-for="child in item.children">
              <a
                v-if="item.isLang"
                :key="child.lang"
                href="javascript:void(0)"
                :class="{ active: lang === child.lang }"
                @click="goLang(child.lang)"
              >
                <span>{{ child.name }}</span>
              </a>
              <router-link v-else-if="child.type || child.hash" :key="child.key" :to="menuTo(item, child)">
                <img :src="fileUrl(child.icon)" :alt="child.name">
                <span>{{ child.name }}</span>
              </router-link>
              <a v-else :key="child.key" href="javascript:void(0)">
                <img :src="fileUrl(child.icon)" :alt="child.name">
                <span>{{ child.name }}</span>
              </a>
            </template>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { fileUrl } from '@/utils/fileUrl'
import { getCopy, langPath, switchLangPath } from '@/locale'

export default {
  name: 'SiteHeader',
  computed: {
    /** 当前站语言 */
    lang() {
      return this.$route.meta && this.$route.meta.lang === 'en' ? 'en' : 'zh'
    },
    /** 当前站文案 */
    copy() {
      return getCopy(this.lang)
    },
    homePath() {
      return langPath(this.lang, '/')
    },
    /** 主导航（含语言切换） */
    menus() {
      const c = this.copy.nav
      const lang = this.lang
      return [
        { key: 'home', name: c.home, path: langPath(lang, '/') },
        { key: 'about', name: c.about, path: langPath(lang, '/about') },
        {
          key: 'transport',
          name: c.transport,
          path: langPath(lang, '/transport'),
          children: [
            { key: 'water', name: c.water, icon: 'shared/nav/水上运输.png', type: 'water' },
            { key: 'road', name: c.road, icon: 'shared/nav/公路运输.png', type: 'road' },
            { key: 'rail', name: c.rail, icon: 'shared/nav/铁路运输.png', type: 'rail' },
            { key: 'air', name: c.air, icon: 'shared/nav/航空运输.png', type: 'air' }
          ]
        },
        {
          key: 'route',
          name: c.route,
          path: langPath(lang, '/route'),
          children: [
            { key: 'sea', name: c.sea, icon: 'shared/nav/东南亚航线.png', hash: 'sea' },
            { key: 'india', name: c.india, icon: 'shared/nav/印巴航线.png', hash: 'india' },
            { key: 'med', name: c.med, icon: 'shared/nav/地中海航线.png', hash: 'med' },
            { key: 'caribbean', name: c.caribbean, icon: 'shared/nav/加勒比航线.png', hash: 'caribbean' },
            { key: 'black', name: c.black, icon: 'shared/nav/黑海线.png', hash: 'black' },
            { key: 'red', name: c.red, icon: 'shared/nav/红海线.png', hash: 'red' },
            { key: 'middle', name: c.middle, icon: 'shared/nav/中东线.png', hash: 'middle' },
            { key: 'us', name: c.us, icon: 'shared/nav/美线.png', hash: 'us' },
            { key: 'europe', name: c.europe, icon: 'shared/nav/欧洲线.png', hash: 'europe' }
          ]
        },
        { key: 'contact', name: c.contact, path: langPath(lang, '/contact') },
        {
          key: 'language',
          name: c.language,
          isLang: true,
          children: [
            { lang: 'zh', name: c.zh },
            { lang: 'en', name: c.en }
          ]
        }
      ]
    }
  },
  methods: {
    /** 拼接文件服务器上的图片地址 */
    fileUrl(path) {
      return fileUrl(path)
    },
    /** 当前菜单是否选中（兼容英文前缀） */
    isActive(path) {
      return this.$route.path === path
    },
    /** 运输业务换中间内容，航线优势跳到整页里对应卡片 */
    menuTo(item, child) {
      if (child.hash) {
        return { path: item.path, hash: '#' + child.hash }
      }
      return { path: item.path, query: { type: child.type } }
    },
    /** 跳转到对应语言页面（同菜单中英文两套路由） */
    goLang(targetLang) {
      if (targetLang === this.lang) {
        return
      }
      const nextPath = switchLangPath(this.$route.fullPath, targetLang)
      this.$router.push(nextPath)
    }
  }
}
</script>

<style scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 30;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
}
.header-inner {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  height: 104px;
  background-color: #fff;
}
.brand {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}
.logo {
  position: absolute;
  top: 21px;
  left: -0.7%;
  width: 7.1%;
  height: 56px;
  object-fit: contain;
  object-position: center;
  pointer-events: auto;
}
.brand-cn {
  position: absolute;
  top: 13px;
  left: 6.541667%;
  width: 30.833333%;
  margin: 0;
  color: #3db7ef;
  font-size: 18px;
  font-weight: normal;
  line-height: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: auto;
}
.brand-en {
  position: absolute;
  top: 54px;
  left: 6.625%;
  width: 33.583333%;
  margin: 0;
  color: #999;
  font-size: 11px;
  font-weight: normal;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: auto;
}
.nav {
  position: absolute;
  top: 30px;
  left: 40%;
  width: 58%;
  height: 44px;
  display: flex;
  align-items: center;
  z-index: 2;
  background-color: #fff;
}
.nav-item {
  flex: 1;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 不设 relative：大下拉相对整条 .nav 左对齐，对齐官网 subBox */
}
/* 项与项之间一条竖线，贴在格子右缘，最后一项不加 */
.nav-item:not(:last-child) {
  background-image: linear-gradient(#e5e5e5, #e5e5e5);
  background-size: 1px 18px;
  background-repeat: no-repeat;
  background-position: right center;
}
.nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 44px;
  line-height: 44px;
  margin: 0 2px;
  padding: 0 10px;
  color: #333;
  font-size: 16px;
  text-decoration: none;
  white-space: nowrap;
  border: 1px solid transparent;
}
/* 英文菜单略加宽，仍均分对齐官网 EN 导航 */
.site-header.is-en .nav {
  left: 36%;
  width: 62%;
}
.site-header.is-en .nav-link {
  padding: 0 6px;
  font-size: 15px;
}
.site-header.is-en .brand-cn,
.site-header.is-en .brand-en {
  width: 32%;
  max-width: 360px;
}
/* 当前选中项：蓝底白字 */
.nav-link.active {
  color: #fff;
  background: #3db7ef;
  border-color: #3db7ef;
}
.nav-item:hover > .nav-link:not(.active) {
  color: #3db7ef;
}
.caret {
  width: 0;
  height: 0;
  margin-left: 6px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid currentColor;
}
/* 下拉挂在整条导航上：left:0 + width:100%，与官网菜单区一致；无顶蓝线 */
.dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-top: none;
  padding: 20px 20px 0;
  z-index: 20;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}
.dropdown::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  height: 8px;
}
.nav-item:hover .dropdown {
  display: flex;
  flex-wrap: wrap;
  animation: fadeIn 0.35s both;
}
.dropdown a {
  display: flex;
  align-items: center;
  width: 32%;
  margin: 0 2% 20px 0;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  line-height: 32px;
  text-decoration: none;
  vertical-align: top;
  box-sizing: border-box;
}
.dropdown a:nth-child(3n) {
  margin-right: 0;
}
.dropdown a:hover {
  color: #007fff;
}
.dropdown img {
  width: 32px;
  height: 32px;
  object-fit: contain;
  margin-right: 8px;
}
/* 语言下拉仍贴右侧菜单项 */
.lang-item {
  position: relative;
}
.lang-dropdown {
  left: auto;
  right: 0;
  width: 140px;
  padding: 8px 0;
  border-top: none;
  flex-direction: column;
  flex-wrap: nowrap;
}
.lang-dropdown a {
  width: 100%;
  margin: 0;
  padding: 8px 16px;
  font-weight: normal;
  box-sizing: border-box;
}
.lang-dropdown a.active {
  color: #007fff;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@media (min-width: 641px) and (max-width: 1200px) {
  .site-header { height: auto; }
  .header-inner { height: 105px; }
  .logo { left: 2%; }
  .brand-cn { top: 14px; left: 10.571315%; width: 167px; }
  .brand-en { top: 48px; left: 10.571315%; width: 156px; }
}
@media (max-width: 640px) {
  .header-inner { height: 91px; }
  .logo { top: 14px; left: 4.265668%; width: 60px; height: 60px; }
  .brand-cn { top: 5px; left: 23.415978%; width: 50.137741%; font-size: 16px; line-height: 28px; }
  .brand-en { top: 35px; left: 23.273933%; width: 42.699725%; }
  .nav { left: auto; right: 0; top: 0; width: auto; height: 100%; }
  .nav-item { flex: none; }
  .nav-link { padding: 0 8px; font-size: 13px; }
}
</style>
